// @ts-nocheck
import walker from './walker.ts';
import getDomPath from './dompath.ts';

const scan = (cache, nonTranslatedText, translatedText) => {
    const walkIt = walker(document.body);

    while (walkIt.nextNode()) {
        const currentNode = walkIt.currentNode;
        prepareNode(currentNode);

        if (shouldSkipNode(currentNode)) continue;

        if (cache) {
            processNodeWithCache(currentNode, cache, nonTranslatedText, translatedText);
        } else {
            processNodeWithoutCache(currentNode, nonTranslatedText, translatedText);
        }
    }

    return { nonTranslatedText, translatedText };
}

const prepareNode = (node) => {
    node.parentNode.classList.add('verbosText');
    node.parentNode.setAttribute('data-verbos-original', node.nodeValue);
}

const shouldSkipNode = (node) => {
    return node.parentNode && 
           node.parentNode.nodeType === Node.ELEMENT_NODE && 
           (node.parentNode.getAttribute('data-translation') === 'true' ||
            node.nodeValue.trim().length === 0);
}

const processNodeWithCache = (node, cache, nonTranslatedText, translatedText) => {
    const itemTrimmed = node.nodeValue.trim();
    let cacheItem = cache.translations.find(item => item.original === itemTrimmed && item.translation !== '');

    if (cacheItem) {
        translatedText.push({ ...cacheItem, path: getDomPath(node.parentNode), cache: true });

        node.nodeValue = node.nodeValue.replace(cacheItem.original, cacheItem.translation);
        node.parentNode.setAttribute('data-verbos-id', cacheItem._id);
        markNodeAsTranslated(node);
    } else {
        addNodeForTranslation(itemTrimmed, node, nonTranslatedText);
    }
}

const processNodeWithoutCache = (node, nonTranslatedText, translatedText) => {
    const itemTrimmed = node.nodeValue.trim();
    addNodeForTranslation(itemTrimmed, node, nonTranslatedText, translatedText);
}

const addNodeForTranslation = (item, node, nonTranslatedText) => {
    if (item.length > 0) {
        const translationObj = {
            original: item,
            translation: '',
            path: getDomPath(node.parentNode),
            cache: false
        };

        nonTranslatedText.push(translationObj);
    }
}

const markNodeAsTranslated = (node) => {
    if (node.parentNode && node.parentNode.nodeType === Node.ELEMENT_NODE) {
        node.parentNode.setAttribute('data-translation', 'true');
    }
}

export default scan;
